import { render } from "./lan-basic.vue?vue&type=template&id=cd423506&scoped=true"
import script from "./lan-basic.vue?vue&type=script&lang=js"
export * from "./lan-basic.vue?vue&type=script&lang=js"

import "./lan-basic.vue?vue&type=style&index=0&id=cd423506&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd423506"]])

export default __exports__